import { rest } from "msw";
import { apiUrl } from "features/configure";

const getIntegrity = rest.get(
  `${apiUrl}/api/integrity/:target`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        version: "1.0.0",
        hash: "fGZu67//CNqyHkMC7g6NCXejHfQ81liN3BPyjUGw+xZCJpypSDQyZDOVqZoLO3brBz4cBqTkFpYhKxvl1CLRRA==",
      })
    );
  }
);

export const integrityMocks = [getIntegrity];
